import s from '../../styles/components/general/CTAButton.module.css';

export default function CTAButton({ id, label, url }) {
  return (
    <a href={url} data-cta-id={id} className={s.button}>
      {label}
    </a>
  );
}